// extracted by mini-css-extract-plugin
module.exports = {"parties":"parties_block-module__parties--cLHUO","text":"parties_block-module__text--1MH1N"};